import { APPLICATION_STATUS } from '../utils/Constants';

export const getBadgeStatus = (statusCode: number) => {
  const mapStatus = new Map();
  mapStatus.set(APPLICATION_STATUS.committee.code, 'success');
  mapStatus.set(APPLICATION_STATUS.approved.code, 'success');
  mapStatus.set(APPLICATION_STATUS.rejected.code, 'danger');
  mapStatus.set(APPLICATION_STATUS.pending.code, 'warning');
  mapStatus.set(APPLICATION_STATUS.revision.code, 'info');
  mapStatus.set(APPLICATION_STATUS.instrumentation.code, 'success');
  mapStatus.set(APPLICATION_STATUS.readyToInstrument.code, 'success');
  mapStatus.set(APPLICATION_STATUS.finished.code, 'neutral');
  return mapStatus.get(statusCode) || 'neutral';
};

export const getTooltipText = (statusCode: number) => {
  const mapStatus = new Map();
  mapStatus.set(APPLICATION_STATUS.instrumentation.code, 'En instrumentación');
  mapStatus.set(APPLICATION_STATUS.readyToInstrument.code, 'Para instrumentar');
  mapStatus.set(APPLICATION_STATUS.finished.code, 'CERRADA');
  mapStatus.set(APPLICATION_STATUS.approved.code, 'En análisis de riesgo');
  mapStatus.set(APPLICATION_STATUS.rejected.code, '');
  mapStatus.set(APPLICATION_STATUS.pending.code, 'Comercial pide cambios');
  mapStatus.set(APPLICATION_STATUS.revision.code, 'Documentación en revisión');
  mapStatus.set(APPLICATION_STATUS.committee.code, 'En evaluación de comité');
  return mapStatus.get(statusCode) || '';
};

export const getStatusText = (
  statusCode: number,
  fallbackText?: string
): string => {
  const status = Object.values(APPLICATION_STATUS).find(
    (item) => item.code === statusCode
  );
  if (status) {
    return status.text;
  }
  // TODO: Cuando el backend devuelva directamente "DENEGADA" y "ACEPTADA" en status.name,
  // eliminar los mapeos de abajo y simplemente retornar fallbackText || 'Estado desconocido'
  // Si no está en Constants, mapear nombres comunes del backend antes de usar como fallback
  if (fallbackText) {
    const nameLower = fallbackText.toLowerCase();
    // Mapear variaciones comunes del backend a los valores de Constants
    if (nameLower === 'rechazada' || nameLower === 'rechazadas') {
      return APPLICATION_STATUS.rejected.text;
    }
    if (nameLower === 'aprobada' || nameLower === 'aceptada') {
      return APPLICATION_STATUS.approved.text;
    }
    // Si no coincide con ningún mapeo conocido, usar el texto del backend
    return fallbackText;
  }
  return 'Estado desconocido';
};
